import React from 'react'

class Vehicles extends React.Component {
  constructor(props) {
    super(props);
    this.state = props.initial_state;
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    
    this.setState({
      [name]: value
    });

  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onChange({...this.state})
    this.props.history.push('/')
  }

  render() {
    return (
        <div>
          <h1>{this.car}</h1>
        
          <form onSubmit={this.handleSubmit}>
            <input type="text" name="label" value={this.state.label} onChange={this.handleChange} placeholder="Label"/>
            <input type="text" name="make" value={this.state.make} onChange={this.handleChange} placeholder="Make"/>
            <input type="text" name="model" value={this.state.model} onChange={this.handleChange} placeholder="Model"/>
            <input type="text" name="year" value={this.state.year} onChange={this.handleChange} placeholder="Year"/>
            <input type="text" name="color" value={this.state.color} onChange={this.handleChange} placeholder="Color"/>
            <input type="text" name="starting_odometer" value={this.state.starting_odometer} onChange={this.handleChange} placeholder="Odometer"/>
            <input type="text" name="trim" value={this.state.trim} onChange={this.handleChange} placeholder="Trim"/>
            <input type="text" name="VIN" value={this.state.VIN} onChange={this.handleChange} placeholder="VIN"/>
            <input type="text" name="plate" value={this.state.plate} onChange={this.handleChange} placeholder="Plate"/>
           
            <div className="button-footer">
               <button>Add Vehicle</button>
            </div>
          </form>
      </div>     
    );
  }
}
 
export default Vehicles


// WEBPACK FOOTER //
// ./src/components/Vehicles/index.js